export default __webpack_public_path__ + "static/poster-fbbfdc93ebed438e8d51fa3993fc4247.png";